export default __webpack_public_path__ + "static/media/banner1.02bcc2d6.jpg";